import { Component, OnInit, ViewChild } from '@angular/core';
import { PageLoaderService } from '../common/services/page-loader.service';
import { SharedService } from '../common/services/shared-service';
import { FileExportService } from '../selection-generic/services/file-export.service';
import { AttributeImportService } from './services/attribute-import.service';

@Component({
    selector: 'app-attribute-import',
    templateUrl: './attribute-import.component.html',
    styleUrls: ['./attribute-import.component.scss'],
    standalone: false
})
export class AttributeImportComponent implements OnInit {
  
  @ViewChild('appParameterPanel') appParameterPanel: any;

  constructor(  
    private sharedService: SharedService,    
    public attributeImportService: AttributeImportService,
    public pageLoaderService: PageLoaderService,
    public fileExportService: FileExportService) { }

  ngOnInit(): void { 
  }


  staffExcelImport(){
    var model = this.appParameterPanel.getParamterControls();     
    model.empresaId = parseInt(localStorage.getItem('Empresa'));
    //check for file
    if(!model.excelfile){
      this.sharedService.ShowSnackBar('Adjunta un fichero Excel');
      return;
    }
    //check if it has columns
    if(model.camposImportacion.length == 0){
      this.sharedService.ShowSnackBar('No hay ningún atributo introducido');
      return;
    }  
    if(!model.primeraFila || model.primeraFila == 0 || model.primeraFila < 1 ){
      this.appParameterPanel.setInvalidFormCOntrol("primeraFila");
      return;
    }
    if(!model.columnaClave || model.columnaClave == 0 || model.columnaClave < 1){
      this.appParameterPanel.setInvalidFormCOntrol("columnaClave");
      return;
    }  
    // upload excel details
     this.staffExcelImportCallMethod(model);       
  }

  staffExcelImportCallMethod(model: any){
    this.pageLoaderService.ShowPageLoader();
    this.attributeImportService.attributeExcelImport(model)
    .subscribe(res => {  
      if (res.code === 0) {     
        //download errors excel file it if the upload fails
        if(res.result && res.result.errorDocument && res.result.errorDocument.file !== null && res.result.errorDocument.file !== undefined){
          this.sharedService.ShowSnackBar('Se han producido errores mostrados en la hoja excel');          
          this.fileExportService.DownloadFile(res.result.errorDocument.file, res.result.errorDocument.fileName);
        }else{
          this.sharedService.ShowSnackBar('Importación realizada correctamente');
        }
      }else{
        this.sharedService.ShowSnackBar('Fallo en el proceso');
        console.error("Error de importación :" + res.message);
      }
      this.pageLoaderService.HidePageLoader();
    }, err => {
      this.sharedService.ShowSnackBar('Fallo en el proceso');
      console.error(err);
      this.pageLoaderService.HidePageLoader();
    });
  }
}
